import React , {useContext, useState } from 'react';
import LocationSlideOne from '../components/LocationSlideOne';
import LocationSlideTwo from '../components/LocationSlideTwo';
import LocationSlideThree from '../components/LocationSlideThree';
import './SingleLocation.css';
import LocationSlideFour from '../components/LocationSlideFour';
import LocationSlideFive from '../components/LocationSlideFive';
import LocationSlideSix from '../components/LocationSlideSix';
import { AppContext } from '../context/AppContext';


const SingleLocation = ( { locationName } ) => {

    const [showing , setShowing] = useState(true);
    const {slideIndex} = useContext(AppContext);
    const [ indexSlideValue  ] = slideIndex;



    function determineComponent(  )  {

        switch(indexSlideValue) {
            case 1:
                return <LocationSlideOne />;

            case 2:
                return <LocationSlideTwo />;

            case 3:
                return <LocationSlideThree />;

            case 4:
                return <LocationSlideFour />;

            case 5:
                return <LocationSlideFive />;

            case 6:
                return <LocationSlideSix locationName={locationName} />;

        }
    }
   

   

  return (
    <div className={`main_single_location  ${showing && 'active' }`} >

        <img src="/images/icons/logo-white.png" alt="" className="icon_big" />
        {determineComponent()}
     
        {showing ? (
            <img src="/images/icons/left-arrow.png" alt="" className="icon_small toggle_nav_icon" onClick={() => setShowing(!showing)}  />
        ) : (
            <img src="/images/icons/right-arrow.png" alt="" className=" right_toggle_nav" onClick={() => setShowing(!showing)}  />
        )}
      

        {/* <div className={`buttons_location_map ${showing && 'active'}`}>
            <img src="/images/icons/left-arrow.png" className='left_arrrow_location' alt="" onClick={() => handleSliding(-1) } />
            <img src="/images/icons/right-arrow.png" className='right_arrrow_location' alt="" onClick={() => handleSliding(+1) } />
        </div> */}

    </div>
  )
}

export default SingleLocation